var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-box",
      on: {
        keydown: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
          ) {
            return null
          }
          return _vm.hideModal($event)
        }
      }
    },
    [
      _c(
        "transition",
        {
          attrs: {
            name: "modalbox-transition",
            "enter-active-class": "animated fadeIn",
            "leave-active-class": "animated fadeOut"
          }
        },
        [
          _vm.modalVisible
            ? _c("div", { staticClass: "modal-box-overlay" })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            name: "modalbox-transition",
            "enter-active-class": "animated fadeInUp",
            "leave-active-class": "animated fadeOutDown"
          }
        },
        [
          _vm.modalVisible
            ? _c(
                "div",
                {
                  staticClass: "modal-box-content",
                  on: {
                    click: function($event) {
                      if ($event.target !== $event.currentTarget) {
                        return null
                      }
                      return _vm.hideModal($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "modal-box-inner-content" },
                    [_c(_vm.component, { tag: "component" })],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf82a0e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf82a0e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalBox/ModalBox.vue
// module id = null
// module chunks = 